import { IsNotEmpty, IsUUID } from "class-validator";

export class RouteIdDTO {

    @IsNotEmpty()
    @IsUUID()
    id: string;

}
